<template>
    <div>
        <b-row>
            <b-col cols="12" md="2" lg="">
                <b-btn variant="primary" @click="$router.push({ name: 'supervisionIndexPage' })" block><i class="fa fa-arrow-left"></i> Volver</b-btn>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-center">
                <h3><slot></slot></h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-center">
                <h5 style="color: #FF761C;">{{ supervisionClient.name }}</h5>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters(['supervisionClient'])
    }
}
</script>